import GameSurface from './Components/GameSurface';

export default function App() {
  return (
    <GameSurface />
  );
}
